import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareService } from '../share-service';
import { ShareIdRepository, EmailInviteRepository } from '../../services/share-tools-repository';
import type { InviteByEmailData, ShareAuthCheckData } from '../../types';

@injectable()
export class ShareServiceImpl implements ShareService {
    constructor(
        @inject(ShareIdRepository) private shareIdRepository: ShareIdRepository,
        @inject(EmailInviteRepository) private emailInviteRepository: EmailInviteRepository
    ) {
    }

    getShareId(data: ShareAuthCheckData) {
        return this.shareIdRepository.getShareId(data);
    }

    inviteByEmail(data: InviteByEmailData) {
        return this.emailInviteRepository.inviteByEmail(data);
    }
}
